import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../../context/user/userContext";
import {
  getSkillStoreDetailsDataById,
  getSkillStoreData,
} from "../../../mks-applications/skillStore/services/skillStoreService";

export const usePermissions = (skillStoreId) => {
  const [owners, setOwners] = useState([]);
  const { state } = useContext(UserContext);
  const [filterSkills, setFilterSkills] = useState([]);
  const permissions = state?.user?.privileges || [];
  const userId = state?.user?.userProfile?.user_id;

  useEffect(() => {
    const fetchSkillDetails = async () => {
      if (skillStoreId) {
        const response = await getSkillStoreDetailsDataById(skillStoreId);
        if (response?.Owner) {
          setOwners(response.Owner);
        }
      }
    };
    fetchSkillDetails();

    const fetchAllSkills = async () => {
      if (skillStoreId === 0) {
        const response = await getSkillStoreData();
        if (response) {
          if (state?.user?.userProfile?.userMSALRole !== "Member") {
            setFilterSkills(
              response.filter((item) => item.IsThirdPartyAITool === false)
            );
          } else {
            let skills = response.filter(
              (item) => item.IsThirdPartyAITool === false
            );
            skills = skills.filter(
              (item) =>
                state?.user?.userProfile.msalSecurityGroup?.some(
                  (group) => group.id === item.SecurityGroupId
                ) || item.Owner.includes(userId)
            );
            setFilterSkills(skills);
          }
        }
      }
    };

    if (skillStoreId === 0) {
      fetchAllSkills();
    }
  }, [skillStoreId]);

  // Find SuperAdmin permissions
  const superAdminPermissions = permissions.find(
    (perm) => perm.EntityName?.toLowerCase() === "superadmin"
  );
  return {
    isSuperAdmin: !!superAdminPermissions,
    canRead: superAdminPermissions?.CanRead || false,
    canCreate: superAdminPermissions?.CanCreate || false,
    canUpdate: superAdminPermissions?.CanUpdate || false,
    canDelete: superAdminPermissions?.CanDelete || false,
    isUserIdExist: owners?.includes(userId),
    isGroupOwner:
      state?.user?.userProfile?.userMSALRole === "Member" ? false : true,
    isDemographicAccess: filterSkills?.length > 0 ? true : false,
    allSkills: filterSkills,
  };
};
